/**
 * HubSpot is hidden from the interface (Kevin's decision, 2026-10-05).
 *
 * Why: AUDIT-INT-08 in docs/cartography/BUGS-OUVERTS.md. A customer's own
 * HubSpot connection is never used (its calls go to the agency's HubSpot
 * portal), and ADR-029 and ADR-036 disagree on which connection should be.
 * Until that is decided, no screen offers HubSpot.
 *
 * Only the front is affected. The backend is unchanged: HubSpot routes,
 * services and stored tokens stay, and a customer whose
 * active_crm_provider is "hubspot" keeps working as before.
 *
 * Restoring every HubSpot screen is this one line.
 */
export const HUBSPOT_UI_ENABLED = false;

/**
 * Whether a CRM provider picker lists HubSpot. Offered only when the HubSpot
 * screens are on, or when HubSpot is the STORED provider: the picker then
 * shows the real configuration instead of an empty box, and saving without
 * touching it keeps the value. Pass the saved value, not the edited one, so
 * the option disappears for good once someone moves away from HubSpot.
 */
export function crmPickerOffersHubspot(storedProvider?: string | null): boolean {
  return HUBSPOT_UI_ENABLED || storedProvider === 'hubspot';
}

/**
 * The CRM provider as the SCREENS should treat it. With the HubSpot screens
 * off, a HubSpot customer reads as having no CRM to show: no "CRM" menu
 * entry, and the CRM screen (reached by URL) says no CRM is connected
 * instead of an empty HubSpot pipeline. Only for display: what the server
 * does with the call (CRM send, booked meetings) is not changed by this.
 */
export function crmProviderShown(provider?: string | null): string {
  const value = provider || 'none';
  return value === 'hubspot' && !HUBSPOT_UI_ENABLED ? 'none' : value;
}
